// src/services/settingsService.js
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery"; // Assuming the same custom axiosBaseQuery is used
import {
  SETTINGS_LIST,
  SETTINGS_UPDATE,
  UPLOAD_FILE,
} from "../../config/constants"; // Adjust endpoints as per your config

const settingsService = createApi({
  reducerPath: "settingsService",
  baseQuery: axiosBaseQuery({ baseUrl: "" }), // Use axiosBaseQuery
  tagTypes: ["Settings"],
  endpoints: (builder) => ({
    getSettings: builder.query({
      query: (bodyData) => ({
        url: SETTINGS_LIST, // Endpoint to fetch settings list
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["Settings"],
    }),
    updateSettings: builder.mutation({
      query: ({ settingsId, updatedData }) => ({
        url: `${SETTINGS_UPDATE}/${settingsId}`, // Endpoint to update a settings
        method: "PUT",
        data: updatedData, // Updated settings data
      }),
      invalidatesTags: ["Settings"],
    }),
    uploadImage: builder.mutation({
      query: (data) => ({
        url: `${UPLOAD_FILE}`, // Endpoint to update a settings
        method: "POST",
        data: data, // Updated settings data
        headers: {
          "content-type" : "multipart/form-data"
        }
      }),
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetSettingsQuery,
  useUpdateSettingsMutation,
  useUploadImageMutation,
} = settingsService;

// Export the reducer to be included in the store
export default settingsService;
